import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=24892fd2&"
import script from "./PaymentSettings.vue?vue&type=script&lang=js&"
export * from "./PaymentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports